export default "__VITE_ASSET__CuGRIuBD__"